import { render } from "./FileDownloadButtons.vue?vue&type=template&id=1126cb09&scoped=true"
import script from "./FileDownloadButtons.vue?vue&type=script&lang=js"
export * from "./FileDownloadButtons.vue?vue&type=script&lang=js"

import "./FileDownloadButtons.vue?vue&type=style&index=0&id=1126cb09&lang=scss&scoped=true"

import exportComponent from "/Users/klaus/Projects/sfdc-happy-soup/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1126cb09"]])

export default __exports__